import { useSelector } from 'react-redux';

import {
  getBasketDuration,
  getCleaningPrestation,
  getCleaningPrestationOptions,
  getMode,
  getPrimaryAppointment,
  getPromotion,
  getUniverseRef,
  getZone,
} from '../ducks/basket-selectors';
import { useGetPricesQuery } from '../queries/prices-queries';
import { useVersionedAt } from './use-versioned-at';

const useGetPrices = () => {
  const cleaningPrestation = useSelector(getCleaningPrestation);
  const cleaningPrestationOptions = useSelector(getCleaningPrestationOptions);
  const duration = useSelector(getBasketDuration);
  const primaryAppointment = useSelector(getPrimaryAppointment);
  const promotion = useSelector(getPromotion);
  const universeReference = useSelector(getUniverseRef);
  const zone = useSelector(getZone);
  const isCreationMode = useSelector(getMode) === 'creation';

  const versionedAt = useVersionedAt();

  const { prices, pricesError } = useGetPricesQuery({
    duration,
    prestationReference: cleaningPrestation?.reference,
    prestationOptionsReferences: cleaningPrestationOptions?.map((option) => option.reference),
    promotionCode: promotion?.code,
    universeReference,
    zone,
    versionedAt,
    isPlatformFeesApplicable: isCreationMode,
    ...(primaryAppointment && { appointment: primaryAppointment }),
  });

  return { prices, pricesError };
};

export default useGetPrices;
